<ion-grid>
  <ion-row>
    <ion-col size="12">
      <!-- Intézményi kapcsoló: a szülő a hónapra egy menüt választ, vagy naponta másikat. -->
      <ion-card>
        <ion-card-header>
          <ion-card-title>Menüválasztás módja</ion-card-title>
          <ion-card-subtitle>
            HAVI: a hónapra egy menü érvényes (a szülő a beszállító oszlopban választja).
            NAPI: a napi cellában a menü sorszáma áll a pipa helyett, és minden napra
            külön menü kérhető. Csak több menü esetén van jelentősége.
          </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <div style="display:flex;gap:12px;align-items:flex-end;flex-wrap:wrap">
            <ion-select style="min-width:220px" fill="outline" label="Menüválasztás" labelPlacement="stacked"
              interface="popover" [(ngModel)]="menuValasztas">
              <ion-select-option value="havi">Havi (egy menü a hónapra)</ion-select-option>
              <ion-select-option value="napi">Napi (naponta választható)</ion-select-option>
            </ion-select>
            <!--  RENDELÉSI HATÁRIDŐ. Eddig csak az adatbázisban élt, a felületen sehol
                  nem lehetett átírni – pedig ezt kérdezik a legtöbbet. -->
            <ion-input style="min-width:220px" fill="outline" type="number" min="0" max="30"
                       label="Határidő (étkezési nap)" labelPlacement="stacked"
                       [(ngModel)]="zarasNap"></ion-input>
            <ion-input style="min-width:160px" fill="outline" type="number" min="0" max="23"
                       label="Óra (0–23)" labelPlacement="stacked"
                       [(ngModel)]="zarasOra"></ion-input>
            <ion-button size="small" color="success" (click)="menuValasztasMentes()">
              <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
            </ion-button>
          </div>
          <!--  AZ ELŐTÖLTÉS GOMB nem minden intézménynél használható: ahol eseti az
                étkezés, ott egy kattintással ír felül egy egész hónapot. -->
          <ion-item lines="none" style="--padding-start:0;--inner-padding-end:0;margin-top:8px">
            <ion-toggle [(ngModel)]="elotoltes" justify="start" labelPlacement="end">
              „Előtöltés" gomb az étkezés képernyőn
            </ion-toggle>
          </ion-item>
          <ion-note color="medium" style="display:block;font-size:.85rem">
            Az <b>Előtöltés</b> a hónap <b>minden</b> étkezési napjára megrendeli az ebédet
            mindenkinek, akinek nyitott étkezési időszaka van. Ahol az alapeset, hogy a gyerek
            jár ebédre, ott ez a hónap eleji munka java részét megspórolja; ahol viszont eseti
            az étkezés, ott kapcsold ki — kikapcsolva a gomb meg sem jelenik.
          </ion-note>
          <ion-note color="medium" style="display:block;margin-top:8px;font-size:.85rem">
            A határidő <b>étkezési napokban</b> számít, nem naptári napokban: a hétvége és a
            szünet nem számít bele. Így egy <b>hétfői</b> ebéd határideje „1 nap" mellett
            <b>péntek</b> {{ zarasOra }}:00 — nem vasárnap. „0 nap" = aznap {{ zarasOra }}:00-ig.
          </ion-note>
        </ion-card-content>
      </ion-card>

      <!--  NAPI JELENLÉTI ÍV. A konyhának a darabszám kell, az iskolának NÉVSOR:
            ki jogosult aznap ebédre. Eddig ezt kézzel másolgatták ki. -->
      <ion-card>
        <!--  OSZTÁLYOK TÁLALÁSI SORRENDJE.
      A turnus a sorrend-szám, és több osztály kaphatja ugyanazt: két épületben
      egyszerre ebédelnek. Ezért az időpont a TURNUSHOZ tartozik, nem az osztályhoz –
      így nem állhat egy turnuson belül két különböző időpont. -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Osztályok étkezési sorrendje</ion-card-title>
    <ion-card-subtitle>
      Melyik osztály hányadik turnusban ebédel, és mikor. <b>Több osztály kaphatja
      ugyanazt a turnust</b> — így jelölöd, hogy egyszerre esznek (pl. két külön épületben).
      Innen dolgozik az <b>ebédkijelző</b>.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content *ngIf="idopont">
    <div class="etk-turnus-sor" style="background:transparent;border:none;padding:0">
      <ion-select style="min-width:150px" fill="outline" label="Tanév" labelPlacement="stacked"
                  interface="popover" [ngModel]="idopontTanev" (ngModelChange)="tanevValt($event)">
        <ion-select-option *ngFor="let e of idopont.tanevek" [value]="e">{{ e }}</ion-select-option>
      </ion-select>
      <!--  AMIT A KIJELZŐ MUTAT. A kijelző a tanulói jogviszonyok szerint választ tanévet,
            nem az osztályok szerint – ha a kettő eltér, a beállítás némán hatástalan
            marad. Ezért kimondjuk, nem a felhasználónak kell rájönnie. -->
      <ion-note color="medium" class="etk-halvany" *ngIf="idopont.kijelzo_tanev === idopont.tanev">
        Ezt a tanévet mutatja az ebédkijelző is.
      </ion-note>
      <ion-note class="etk-figy" *ngIf="idopont.kijelzo_tanev && idopont.kijelzo_tanev !== idopont.tanev">
        <b>Az ebédkijelző a(z) {{ idopont.kijelzo_tanev }}-os tanévet mutatja</b>, nem ezt.
        Amit itt beállítasz, azon a kijelzőn nem fog látszani.
      </ion-note>
    </div>
    <ion-note color="medium" style="font-size:.82rem; display:block">
      <span *ngIf="idopont.idegen" class="etk-figy">
        <br><b>Figyelem:</b> {{ idopont.idegen }} beosztás még <b>korábbi tanév</b> osztályaira
        mutat. Azok a kijelzőn nem érvényesülnek — az ittenieket kell beállítani.
      </span>
    </ion-note>

    <!-- Beosztás: osztályonként a turnus száma -->
    <div class="etk-tabla-doboz">
      <table class="etk-tabla">
        <thead><tr><th>Osztály</th><th class="szam">Turnus</th><th>Időpont</th></tr></thead>
        <tbody>
          <tr *ngFor="let o of idopont.osztalyok; trackBy: trackOsztaly">
            <td>{{ o.osztaly }}</td>
            <td class="szam">
              <ion-input type="number" min="1" max="99" class="etk-turnus" fill="outline"
                         placeholder="—" [ngModel]="o.sorrend"
                         (ngModelChange)="osztalyTurnus(o, $event)"></ion-input>
            </td>
            <td class="etk-halvany">{{ o.ido || (o.sorrend ? 'a turnusnál állítható' : 'nincs beosztva') }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Turnusok: itt látszik, KI ESZIK EGYSZERRE, és itt áll az időpont -->
    <h3 style="font-size:1rem;margin:14px 0 6px">Turnusok</h3>
    <div class="etk-turnus-sor" *ngFor="let t of turnusok; trackBy: trackTurnus">
      <b class="etk-turnus-szam">{{ t.sorrend }}.</b>
      <ion-input class="etk-ido" fill="outline" labelPlacement="stacked" label="Időpont"
                 placeholder="11:30" [ngModel]="t.ido" (ngModelChange)="turnusIdo(t, $event)"></ion-input>
      <span class="etk-osztalyok">
        <ion-chip *ngFor="let o of t.osztalyok; trackBy: trackOsztaly" outline="true">{{ o.osztaly }}</ion-chip>
        <span class="etk-halvany" *ngIf="t.osztalyok.length > 1">— egyszerre esznek</span>
      </span>
    </div>
    <div class="etk-halvany" *ngIf="!turnusok.length">Még egy osztály sincs turnusba osztva.</div>

    <div class="etk-halvany" *ngIf="beosztatlanok.length" style="margin-top:8px">
      <b>Nincs beosztva:</b>
      <ion-chip *ngFor="let o of beosztatlanok" outline="true">{{ o.osztaly }}</ion-chip>
      — a kijelzőn a lista végén, időpont nélkül jelennek meg.
    </div>

    <ion-button size="small" color="success" (click)="idopontMentes()" [disabled]="idopontFut"
                style="margin-top:10px">
      <ion-icon slot="start" name="save-outline"></ion-icon>
      {{ idopontFut ? 'Mentés…' : 'Sorrend mentése' }}
    </ion-button>
  </ion-card-content>
  <ion-card-content *ngIf="!idopont">
    <ion-spinner name="crescent" *ngIf="idopontFut"></ion-spinner>
    <span class="etk-halvany" *ngIf="!idopontFut">Nincs betöltve tanév vagy osztály.</span>
  </ion-card-content>
</ion-card>

<ion-card-header>
          <ion-card-title>Napi jelenléti ív</ion-card-title>
          <ion-card-subtitle>
            Ki vette át az ebédet — névsor osztály szerint, aláírás-rovattal, Excelben.
          </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <div style="display:flex;gap:12px;align-items:flex-end;flex-wrap:wrap">
            <ion-input style="min-width:200px" fill="outline" type="date" label="Nap"
                       labelPlacement="stacked" [(ngModel)]="jelenletiNap"></ion-input>
            <ion-button size="small" fill="outline" color="medium" (click)="jelenletiMegnez()"
                        [disabled]="jelenletiFut">
              <ion-icon slot="start" name="eye-outline"></ion-icon>Megnézem
            </ion-button>
            <ion-button size="small" color="success" (click)="jelenletiExcel()">
              <ion-icon slot="start" name="download-outline"></ion-icon>Letöltés Excelbe
            </ion-button>
          </div>

          <ion-note color="medium" style="display:block;margin-top:8px;font-size:.85rem"
                    *ngIf="jelenletiElonezet">
            {{ jelenletiElonezet.datum }} — <b>{{ jelenletiElonezet.osszes }} fő</b>
          </ion-note>
          <div style="max-height:260px;overflow:auto;margin-top:8px" *ngIf="jelenletiElonezet?.tetelek?.length">
            <table class="tabla" style="width:100%;font-size:.85rem">
              <thead><tr><th>Osztály</th><th>Név</th><th>Menü</th><th>Beszállító</th></tr></thead>
              <tbody>
                <tr *ngFor="let t of jelenletiElonezet.tetelek">
                  <td>{{ t.osztaly }}</td><td>{{ t.nev }}</td><td>{{ t.menu }}</td><td>{{ t.beszallito }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ion-note color="medium" style="display:block;margin-top:8px;font-size:.85rem"
                    *ngIf="jelenletiElonezet && !jelenletiElonezet.tetelek?.length">
            Erre a napra nincs rendelés.
          </ion-note>
        </ion-card-content>
      </ion-card>

      <!--  NAPI HIÁNYZÓK (#1070): az aznapra ebédet rendeltek közül ki hiányzik, és ki
            reggel óta – annak az ebédje kiadható másnak. -->
      <ion-card>
        <ion-card-header>
          <ion-card-title>Napi hiányzók (ebéd)</ion-card-title>
          <ion-card-subtitle>
            Dátum szerint: az aznapra ebédet rendelt tanulók közül ki hiányzik, hányadik órákról,
            és ki <b>reggel óta</b> — az ő ebédje kiadható másnak. Az Étkezés képernyőről is elérhető.
          </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <app-etkezes-napi-hianyzok *ngIf="sajatIntezmeny" [intezmeny]="sajatIntezmeny.intezmenyId"></app-etkezes-napi-hianyzok>
        </ion-card-content>
      </ion-card>

      <!--  ÉTLAP: a beszállító heti Excelje → mit főznek naponta menünként. Ebből látja a szülő
            a rendelésnél, mi van az „A” és a „B” mögött, a diák pedig az Étlap menüpontban. -->
      <app-etlap-admin *ngIf="sajatIntezmeny" [intezmeny]="sajatIntezmeny.intezmenyId"></app-etlap-admin>

      <ion-card>
        <ion-card-header>
          <ion-card-title>Étkezési menük (beszállítónként)</ion-card-title>
          <ion-card-subtitle>
            A rendelés a MENÜ alapján megy: a menü hordozza az árat, és a diétás igény is külön menü
            (nincs többé laktóz/glutén felár). A szülő beszállítót és menüt is válthat, a rendelés
            pedig menünkénti darabszámmal megy ki a beszállítónak.
          </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <div *ngFor="let hely of allomany" style="margin-bottom:18px; border-bottom:1px solid #eee; padding-bottom:12px">
            <h4 style="margin:4px 0">{{hely.nev}} <span style="color:#888;font-weight:normal">(alapár: {{hely.ar}} Ft)</span></h4>
            <table style="width:100%; border-collapse:collapse; font-size:13px">
              <thead>
                <tr>
                  <th style="text-align:left;padding:4px">Menü neve</th>
                  <th style="text-align:left;padding:4px">Ár (Ft)</th>
                  <th style="text-align:left;padding:4px">Sorrend</th>
                  <th style="padding:4px"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of menukByHely[hely.id]">
                  <td style="padding:4px"><ion-input [(ngModel)]="m.nev"></ion-input></td>
                  <td style="padding:4px"><ion-input type="number" [(ngModel)]="m.ar"></ion-input></td>
                  <td style="padding:4px"><ion-input type="number" [(ngModel)]="m.sorrend"></ion-input></td>
                  <td style="padding:4px;white-space:nowrap">
                    <ion-button size="small" color="success" (click)="menuMentes(m)">
                      <ion-icon slot="icon-only" name="save-outline"></ion-icon>
                    </ion-button>
                    <ion-button size="small" color="danger" (click)="menuTorles(m, hely.id)">
                      <ion-icon slot="icon-only" name="trash"></ion-icon>
                    </ion-button>
                  </td>
                </tr>
                <tr>
                  <td style="padding:4px"><ion-input placeholder="Új menü neve" [(ngModel)]="ujMenuModel(hely.id).nev"></ion-input></td>
                  <td style="padding:4px"><ion-input type="number" [(ngModel)]="ujMenuModel(hely.id).ar"></ion-input></td>
                  <td style="padding:4px"><ion-input type="number" [(ngModel)]="ujMenuModel(hely.id).sorrend"></ion-input></td>
                  <td style="padding:4px">
                    <ion-button size="small" color="primary" (click)="menuHozzaad(hely)">
                      <ion-icon slot="icon-only" name="add"></ion-icon>
                    </ion-button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Rendelés kiküldése: csatorna, címzett és napi időpont beszállítónként. -->
            <div style="display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end;margin-top:10px">
              <ion-select style="min-width:150px" fill="outline" label="Rendelés küldése" labelPlacement="stacked"
                interface="popover" [(ngModel)]="hely.uzenetkuldes" placeholder="nincs">
                <ion-select-option [value]="null">nincs</ion-select-option>
                <ion-select-option value="email">E-mail</ion-select-option>
                <ion-select-option value="sms">SMS</ion-select-option>
              </ion-select>
              <!--  TÖBB CÍMZETT. A konyha ritkán egy postafiók: gyakran a szakács, az
                    élelmezésvezető és a könyvelés is kéri a rendelést. -->
              <ion-input style="min-width:300px" fill="outline" labelPlacement="stacked"
                label="Címzettek (e-mail vagy telefonszám)" [(ngModel)]="hely.uk_helye"
                placeholder="konyha@beszallito.hu, elelmezes@beszallito.hu"></ion-input>
              <ion-input style="max-width:130px" fill="outline" labelPlacement="stacked" label="Időpont (ÓÓ:PP)"
                [(ngModel)]="hely.uk_ora" placeholder="14:00"></ion-input>
              <ion-button size="small" color="success" (click)="kuldesBeallitasMentes(hely)">
                <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
              </ion-button>
              <ion-button size="small" color="secondary" (click)="rendelesElonezet(hely)">
                <ion-icon slot="start" name="eye-outline"></ion-icon>Előnézet
              </ion-button>
              <ion-note color="medium" style="font-size:.78rem; flex-basis:100%">
                Több címzett is megadható <b>vesszővel</b>, pontosvesszővel vagy szóközzel elválasztva.
                Ha a levelezőszerver egy levélben nem vállal ennyi címzettet (SMTP 452), a rendszer
                <b>magától újrapróbálja címzettenként külön levélben</b>, és megmondja, ki maradt ki.
              </ion-note>
              <ion-button size="small" color="primary" (click)="rendelesKuldes(hely)">
                <ion-icon slot="start" name="send-outline"></ion-icon>Küldés most
              </ion-button>
            </div>
            <!-- amit az ütemező lát: ebből derül ki, miért marad el egy időzített küldés -->
            <div *ngIf="kuldesAllapot[hely.id] as a" style="margin-top:8px;font-size:13px">
              <ion-text [color]="kuldesAllapotSzin(a)"><b>Automatikus kiküldés:</b> {{ kuldesAllapotSzoveg(a) }}</ion-text>
              <div *ngIf="a.naplo?.length" style="font-size:12px;color:var(--ion-color-medium-shade);margin-top:2px">
                Utolsó: {{ a.naplo[0].kuldve | date:'yyyy-MM-dd HH:mm' }} – {{ a.naplo[0].datum }} napra,
                {{ a.naplo[0].statusz === 'ok' ? 'kiment' : a.naplo[0].statusz }}{{ a.naplo[0].hiba ? ': ' + a.naplo[0].hiba : '' }}
              </div>
              <div *ngIf="utemezoAllapot && !utemezoAllapot.utolso_kor" style="font-size:12px;color:var(--ion-color-danger)">
                Az ütemező a szerver legutóbbi indulása óta még nem futott le.
              </div>
              <div *ngIf="utemezoAllapot?.utolso_hiba" style="font-size:12px;color:var(--ion-color-danger)">
                Ütemező-hiba: {{ utemezoAllapot.utolso_hiba }}
              </div>
            </div>
            <ion-note color="medium" style="display:block;margin-top:6px;font-size:12px">
              A megadott időpontban (magyar idő szerint) a KÖVETKEZŐ napra szóló rendelés megy ki,
              naponta egyszer – a hétfői rendelés tehát vasárnap. Ha másnapra senki nem kért
              étkezést, nem megy levél.
            </ion-note>
            <div *ngIf="elonezet[hely.id]" style="margin-top:8px;background:#f6f8fb;padding:8px;border-radius:6px;font-size:13px">
              <b>{{elonezet[hely.id].datum}}</b> – összesen {{elonezet[hely.id].osszes}} adag
              <div *ngFor="let m of elonezet[hely.id].menuk">• {{m.nev}}: <b>{{m.db}}</b> adag</div>
              <div *ngIf="!elonezet[hely.id].menuk?.length">Erre a napra nincs rendelés.</div>
            </div>
          </div>
          <ion-note color="medium" *ngIf="!allomany?.length">Nincs étkezőhely ehhez az intézményhez.</ion-note>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="3">



      <ion-card style="height: 100%" *ngIf="sajatIntezmeny">
        <ion-card-header>
          <ion-card-title><span style="vertical-align: -webkit-baseline-middle;">Szűrő</span>
          </ion-card-title>
        </ion-card-header>
        <ion-card-content
          style="padding-top:10px !important; padding-left:10px !important; padding-right:10px !important; padding-bottom: 0 !important;">
          <ng-container>

            <ion-input label="Név" label-placement="stacked" fill="outline" placeholder=""></ion-input><br>
            <ion-input label="Oktatási azonosító" label-placement="stacked" fill="outline"
              placeholder=""></ion-input><br>
            <ion-input label="Felhasználónév" label-placement="stacked" fill="outline" placeholder=""></ion-input>
            <ion-grid>
              <ion-row>
                <ion-col size="6">
                  <ion-button color="primary" expand="block">
                    <ion-icon slot="start" name="search"></ion-icon>
                    Keresés
                  </ion-button>
                </ion-col>
                <ion-col size="6">
                  <ion-button color="dark" expand="block">
                    <ion-icon slot="start" name="close"></ion-icon>
                    Törlés
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>

          </ng-container>
        </ion-card-content>
      </ion-card>



    </ion-col>
    <ion-col size="9">

      <div style="margin-top: 10px;">
        <ion-button color="primary" id="uzenet" (click)="ujHely()">
          <ion-icon slot="start" name="add"></ion-icon>
          Új
        </ion-button>
        <ion-button color="secondary" [disabled]="selected.length==0" (click)="initModal(selected[0]?.id)">
          <ion-icon slot="start" name="create"></ion-icon>
          Módosítás
        </ion-button>
        <ion-button color="danger" [disabled]="selected.length==0" (click)="helyTorles(selected[0])">
          <ion-icon slot="start" name="trash"></ion-icon>
          Törlés
        </ion-button>
      </div>
      <ng-container>
        <ngx-datatable (select)="onSelect($event)"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz"
          [rows]="allomany" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [limit]="10"
          [rowClass]="getRowClass" [sorts]="[
  { prop: 'created_at', dir: 'desc' },
  { prop: 'updated_at', dir: 'desc' },
  { prop: 'priority', dir: 'desc' },
  { prop: 'deadline', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column name="Név" prop="created_at">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Név</b>
              {{ row.nev }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Ár" prop="ar">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <b class="mobil">Ár</b>
              {{ value }} Ft
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Laktózmentes" prop="laktoz">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Laktózmentes</b>
              <input type="checkbox" [checked]="value" disabled />
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Gluténmentes" prop="gluten">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Gluténmentes</b>
              <input type="checkbox" [checked]="value" disabled />
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Műveletek</b>
              <ion-button color="secondary" size="small" style="margin-top:0" (click)="initModal(row.id)">
                <ion-icon slot="icon-only" name="create"></ion-icon>

              </ion-button>
              <ion-button color="danger" size="small" style="margin-top:0" (click)="helyTorles(row)">
                <ion-icon slot="icon-only" name="trash"></ion-icon>

              </ion-button>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>



    </ion-col>
  </ion-row>
</ion-grid>









<!-- ÉTKEZŐHELY (beszállító) felvétele/módosítása.
     Itt korábban az ÁLLOMÁNY hat füles személyi adatlapja állt (Személyes, Munkaügy,
     KAS, Végzettség…), a mentése pedig üres függvény volt: sem felvenni, sem
     módosítani nem lehetett étkezőhelyet. -->
<ion-modal style="z-index: 1000" #uzenetmodal trigger="uzenet">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>{{ helyForm.id ? 'Étkezőhely módosítása' : 'Új étkezőhely' }}</ion-title>
        <ion-buttons slot="end">
          <ion-button style="background: white; border-radius: 5px" (click)="helyMentes()"
                      [strong]="true" shape="round" color="secondary">Mentés</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-note color="medium" style="display:block;font-size:12px;margin-bottom:10px">
        A beszállító alapára akkor számít, ha a naphoz nincs menü rendelve; egyébként a
        MENÜ ára az irányadó (a menüket a bal oldali listában lehet felvenni).
        A kiküldés csatornáját, címzettjét és időpontját szintén ott lehet beállítani.
      </ion-note>

      <ion-grid>
        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Beszállító neve" label-placement="stacked" fill="outline"
                       [(ngModel)]="helyForm.nev" placeholder="pl. Zöld Öböl Kft"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Alapár (Ft/adag)" label-placement="stacked" fill="outline"
                       type="number" [(ngModel)]="helyForm.ar"></ion-input>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-checkbox labelPlacement="end" [(ngModel)]="helyForm.laktoz">
              Laktózmentes étkezést biztosít
            </ion-checkbox>
            <ion-input label="Laktózmentes felár (Ft)" label-placement="stacked" fill="outline"
                       type="number" [(ngModel)]="helyForm.laktoz_felar"
                       [disabled]="!helyForm.laktoz" style="margin-top:8px"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-checkbox labelPlacement="end" [(ngModel)]="helyForm.gluten">
              Gluténmentes étkezést biztosít
            </ion-checkbox>
            <ion-input label="Gluténmentes felár (Ft)" label-placement="stacked" fill="outline"
                       type="number" [(ngModel)]="helyForm.gluten_felar"
                       [disabled]="!helyForm.gluten" style="margin-top:8px"></ion-input>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ng-template>
</ion-modal>